/**
 * Blog Tokens
 *
 * Only includes values that DIFFER from the main DVD tokens.
 * For values not listed here, use the main DVD tokens from '@dvd/tokens'.
 */
import { minWidthMediaQuery } from '@dvd/tokens';

/**
 * Breakpoints that apply to article pages only.
 *
 * `article` sits between the shared `large` (1025px) and `xl` (1440px) steps.
 * It exists because the article template's left margin — the space a 40rem
 * centred article leaves inside the section — is what the docked rail is sized
 * from, and that margin does not become usable at the same width the shared
 * scale changes at. At `large` the rail would be ~96px, too narrow for a
 * heading and a byline; at 1200px it is ~184px.
 *
 * Scoped here rather than added to the shared scale: it describes this one
 * template's proportions, and a new global step would invite unrelated
 * components to key off a width that means nothing to them.
 */
const breakpoints = {
  article: '1200px',
};

const mq = {
  minWidth: {
    article: minWidthMediaQuery(breakpoints.article),
  },
};

const typography = {
  fontSize: {
    title: '2.25rem',
    headingOne: '1.5rem',
    headingTwo: '1.125rem',
    headingThree: '0.875rem',
    headingFour: '0.75rem',

    desktop: {
      title: '3rem',
      headingOne: '2.25rem',
      headingTwo: '1.5rem',
      headingThree: '1.125rem',
      headingFour: '0.875rem',
      bodyXs: '0.875rem',
    },
  },

  lineHeight: {
    bodyMd: '1.6',
    bodySm: '1.6',
    bodyXs: '1.6',

    desktop: {
      bodyMd: '1.8',
      bodySm: '1.8',
      bodyXs: '1.8',
    },
  },

  fontWeight: {
    headingOne: '600',
  },
};

export const blogTokens = { breakpoints, mq, typography };
